module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCond.3ea81583.otf";